import { Component, ViewChild } from '@angular/core';
import { MeteringPointQueryResultDto, MeteringPointService, MeteringPointType, PhysicalStatus, } from '@app/api/dmc';
import { meteringPointTable } from '@shared/table-configs/meteringpoint/meteringpoint.table';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { TableComponent } from '@shared/components/table/table.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { CardComponent } from '@shared/components/card/card.component';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { Observable } from 'rxjs';
import { removeNullKeys } from '@app/core/utils/remove-null-keys';
import { AlertService } from '@app/core/services/alert.service';
import { ModalService } from '@app/core/services/modal.service';
import { SortParam } from '@app/core/constants/sort-param';

@Component({
  selector: 'app-find-meteringpoint-modal',
  imports: [
    TableComponent,
    ButtonDirective,
    CardComponent,
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    SelectDirective,
    TranslatePipe
  ],
  templateUrl: './find-meteringpoint-modal.component.html',
  styleUrl: './find-meteringpoint-modal.component.css'
})
export class FindMeteringpointModalComponent {
  @ViewChild('table', { static: false }) public table!: TableComponent<MeteringPointQueryResultDto>;

  public meteringPointTable: TableConfig<MeteringPointQueryResultDto> = {
    ...meteringPointTable,
    columnSelection: false,
    columns: [
      {
        ...meteringPointTable.columns[0],
        cellRenderer: undefined,
      },
      meteringPointTable.columns[1],
      meteringPointTable.columns[2],
      meteringPointTable.columns[3],
      meteringPointTable.columns[4],
      meteringPointTable.columns[6],
      meteringPointTable.columns[8],
    ],
    serviceCallback: (pageSize: number, page: number, order?: SortParam) => this.search(pageSize, page, order),
  }

  public selectedElements: MeteringPointQueryResultDto[] = [];

  /** Dropdown Values **/
  public meteringPointTypeOptions: KeyValue[] = enumToKeyValue(MeteringPointType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.meteringpointtype.' });
  public physicalStatusOptions: KeyValue[] = enumToKeyValue(PhysicalStatus, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.physicalstatus.' });

  /** Search Form **/
  public searchForm: FormGroup = new FormGroup({
    identification: new FormControl(),
    streetName: new FormControl(),
    buildingNumber: new FormControl(),
    floorIdentification: new FormControl(),
    postalCode: new FormControl(),
    meteringPointType: new FormControl(),
    physicalStatus: new FormControl(),
    meterNumber: new FormControl(),
  });

  constructor(
    private readonly meteringPointService: MeteringPointService,
    private readonly alertService: AlertService,
    private readonly modalService: ModalService,
  ) {

  }

  public search(pageSize: number, page: number, order?: SortParam): Observable<any> {
    const sort = order ? { SortParams: [order] } : {};
    const query = removeNullKeys(this.searchForm.value);
    return this.meteringPointService.meteringPointQueryFromSearchPagePost({ ...query, page, pageSize, ...sort });
  }


  public submit(): void {
    if (this.selectedElements.length === 0) {
      this.alertService.open('modal', 'danger', 'meteringPoint.search.selectWarning');
      return;
    }

    if (this.selectedElements.length === 1) {
      this.modalService.close(this.selectedElements[0].identification);
    }
  }

}
